export function slugFromPackageName(name) {
  return String(name || '')
    .trim()
    .toLowerCase()
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '');
}

export const defaultPackageFormData = {
  name: '',
  slug: '',
  description: '',
  price: {
    monthly: '',
    annually: '',
  },
  limits: {
    employees: 1,
  },
  features: [],
  subscription: {
    gracePeriodDays: 7,
    autoRenew: true,
    trialDays: 0,
    billingOptions: ['monthly', 'annually'],
    annualDiscount: 20,
  },
  isActive: true,
  isAdminPackage: false,
  isTrialPackage: false,
};

export function parseEmployeeLimit(value, fallback = 1) {
  if (value === '' || value === '-' || value == null) return fallback;
  const parsed = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(parsed)) return fallback;
  if (parsed === -1 || parsed < 0) return -1;
  return Math.trunc(parsed);
}

export function normalizePackageLimits(limits = {}) {
  return {
    employees: parseEmployeeLimit(limits.employees, 1),
  };
}

export function mapPackageToFormData(pkg) {
  let features = [];
  if (Array.isArray(pkg.features)) {
    features = pkg.features;
  } else if (pkg.features && typeof pkg.features === 'object') {
    features = Object.entries(pkg.features)
      .filter(([, enabled]) => enabled)
      .map(([key]) => key.replace(/([A-Z])/g, ' $1').trim());
  }

  return {
    name: pkg.name,
    slug: pkg.slug || slugFromPackageName(pkg.name),
    description: pkg.description,
    price: pkg.price,
    limits: normalizePackageLimits(pkg.limits),
    features,
    subscription: pkg.subscription,
    isActive: pkg.isActive,
    isAdminPackage: pkg.isAdminPackage,
    isTrialPackage: false,
  };
}
